import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { EndpointsService, NotificationService } from '../core/services';

@Injectable()
export class MediationService {
    private static notificationService;
    constructor(private http: Http, private endpointsService: EndpointsService, private notificationService: NotificationService) {
        MediationService.notificationService = notificationService;
    }

    public getCarouselOrder(publisherId: number, countryId: number): Observable<Response> {
        return this.http.get(this.endpointsService.GET_CAROUSEL_ORDER_URL + '?publisherId=' + publisherId + '&countryId=' + countryId)
            .catch(this.handleError);
    }

    public getCountriesByPublisher(publisherId: number): Observable<Response> {
        return this.http.get(this.endpointsService.GET_COUNTRIES_BY_PUBLISHER_URL + "?publisherId=" + publisherId)
            .catch(this.handleError);
    }

    public getProviderByName(providerName: string): Observable<Response> {
        return this.http.get(this.endpointsService.GET_PROVIDER_BY_NAME_URL + "?providerName=" + providerName)
            .catch(this.handleError);
    }

    public updateCarouselOrder(updatedOrder: Array<number>): Observable<Response> {
        return this.http.post(this.endpointsService.UPDATE_CAROUSEL_ORDER_URL, updatedOrder)
            .catch(this.handleError);
    }

    private handleError(error: Response) {
        if (error.status === 400)
            MediationService.notificationService.showError(error.json().message)
        else
            MediationService.notificationService.showError();
        return Observable.throw(error.json().error || 'Server Error');
    }
}


// WEBPACK FOOTER //
// ./src/app/mediation/mediation.service.ts